module.exports = __webpack_public_path__ + "static/arditi-hex-gray-e8de24d839a926008e19bf61858172be.png";